import { Component, AfterViewInit, HostListener } from '@angular/core';
import { AuthenticationService } from '../_services/index';
import {Router} from "@angular/router"
import { environment } from '../../environments/environment';
import * as Prism from 'prismjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {
    copyright = {
        version: environment.APP_VERSION,
        year: environment.YEAR,
        name: environment.NAME
    }
    private authorized:any;
    constructor(
        private router: Router,
        public as: AuthenticationService,
    ){
        this.authorized = this.as.checkAuthentication();
        if(this.authorized.authorized){
            this.router.navigate(['/inicio']);
        }
        
    }
    ngAfterViewInit() {
        Prism.highlightAll();
    }
    changePage(page){
        this.router.navigate(['/'+page])
    }
}